<template>
  <img :src="src" :alt="alt" class="img-fluid rounded-circle avatar" />
</template>

<script>
export default {
  name: "Avatar",
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.avatar {
  width: 60px;
  height: 60px;
  object-fit: cover;
  background: $gray-200;
}
</style>
